import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import {
  CreateAreaRecord,
  FetchAreaById,
  FetchRegionList,
  FetchStateList,
  UpdateAreaRecord,
} from "../../../services/locationService";
import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { GetCompanyData } from "services/CompanyService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const EditArea = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { areaId } = useParams();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [AreaPayload, setAreaPayload] = useState({
    status: "1",
  });
  const [AreaManager, setAreaManager] = useState([]);
  const [CountryData, setCountryData] = useState([]);
  const [countryIdSelected, setCountryIdSelected] = useState(false);
  const [RegionData, setRegionData] = useState([]);
  const [StateData, setStateData] = useState([]);
  const [CityData, setCityData] = useState([]);

  const handleInput = event => {
    const { name, value } = event.target;

    setAreaPayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCountrySelection = CountryID => {
    setAreaPayload(prevState => ({
      ...prevState,
      country_id: CountryID,
      region_id: null,
      state_id: null,
      city_id: null,
    }));
  };
  const handleRegionSelection = RegionID => {
    setAreaPayload(prevState => ({
      ...prevState,
      region_id: RegionID,
      state_id: null,
      city_id: null,
    }));
  };
  const handleStateSelection = StateID => {
    setAreaPayload(prevState => ({
      ...prevState,
      state_id: StateID,
      city_id: null,
    }));
  };
  const handleCitySelection = CityID => {
    setAreaPayload(prevState => ({
      ...prevState,
      city_id: CityID,
    }));
  };

  const handleAreaManager = area_manager => {
    setAreaPayload(prevState => ({
      ...prevState,
      area_manager: area_manager,
    }));
  };

  const EditArea = payload => {
    UpdateAreaRecord(payload, areaId)
      .then(response => {
        setIsLoading(false);
        toast.success(t(`Location_Manager.Area updated`));
        history.push("/area-list");
      })
      .catch(err => {
        setIsLoading(false);

        let msg =
          err?.response?.data?.message ||
          err?.message ||
          t(`Location_Manager.Edit Area err`);
        toast.error(msg);

        if (Object.keys(err?.response?.data?.message?.errors || {})?.length) {
          setErrors(err?.response?.data?.message?.errors || {});
        }
      });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (!AreaPayload?.country_id) {
      errorObj["country_id"] = t(`Location_Manager.Country required`);
    }

    // if (!AreaPayload?.region_id) {
    //   errorObj["region_id"] = "Region is required";
    // }

    if (!AreaPayload?.state_id) {
      errorObj["state_id"] = t(`Location_Manager.State required`);
    }

    if (!AreaPayload?.city_id) {
      errorObj["city_id"] = t(`Location_Manager.City required`);
    }

    if (!AreaPayload?.area_name) {
      errorObj["area_name"] = t(`Location_Manager.Area name required`);
    }

    // if (!AreaPayload?.area_code) {
    //   errorObj["area_code"] = t(`Location_Manager.Area code required`);
    // }

    // if (!AreaPayload?.email) {
    //   errorObj["email"] = t(`Location_Manager.Email required`);
    // }

    // if (!AreaPayload?.area_manager) {
    //   errorObj["area_manager"] = t(`Location_Manager.Area manager required`);
    // }

    // if (!AreaPayload?.address) {
    //   errorObj["address"] = t(`Location_Manager.Address required`);
    // }

    if (Object.keys(errorObj)?.length > 0) {
      setIsLoading(false);
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));

      return;
    }

    let reqData = {
      country_id: AreaPayload?.country_id,
      region_id: AreaPayload?.region_id,
      state_id: AreaPayload?.state_id,
      city_id: AreaPayload?.city_id,
      area_name: AreaPayload?.area_name,
      area_code: AreaPayload?.area_code,
      email: AreaPayload?.email,
      area_manager: AreaPayload?.area_manager,
      address: AreaPayload?.address,
      status: AreaPayload?.status,
    };
    let encryptedQuery = encryptDataToArray(reqData);

    let payload = new FormData();
    payload.append("reqData", JSON.stringify(encryptedQuery));

    EditArea(payload);
  };

  const fetchAreaManagerData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/store/store-manager`)
      .then(response => {
        const allManager = response.data.data;
        let data = allManager?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.name,
        }));
        setAreaManager(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const fetchCountryData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/country-list`)
      .then(response => {
        const { success, allCountry } = response.data;
        if (success) {
          const { allCountry } = response.data;
          let data = allCountry?.map(item => ({
            id: item?.id,
            label: item?.name,
            value: item?.name,
          }));
          setCountryData(data);
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchRegionData = () => {
    FetchRegionList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allRegion = response?.data?.filter(item => item.status === 1) || [];
        let data = allRegion?.map(item => ({
          id: item?.id,
          label: item?.region,
          value: item?.region,
          country_id: item?.country_id,
        }));
        setRegionData(data);
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchStateData = () => {
    FetchStateList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const StateList = response?.data?.filter(item => item.status === 1) || [];
        let data = StateList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.name,
          country_id: item?.country_id,
          region_id: item?.region_id,
        }));
        setStateData(data);
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchCityData = async () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/city-list`)
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const CityList = response?.data?.filter(item => item.status === 1) || [];
        let data = CityList?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.city,
          country_id: item?.country_id,
          region_id: item?.region_id,
          state_id: item?.state_id,
        }));
        setCityData(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const GetArea = () => {
    FetchAreaById(areaId)
      .then(res => {
        let areaData = res?.data?.data || {};
        // areaData = decryptDataFromArray(areaData);
        setAreaPayload(areaData);
        setCountryIdSelected(true);
      })
      .catch(err => {});
  };

  useEffect(() => {
    fetchAreaManagerData();
    fetchCountryData();
    fetchRegionData();
    fetchStateData();
    fetchCityData();
    GetArea();
  }, []);

  
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("area-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }
  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/area-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Location_Manager.Edit Area`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Row>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Country`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="country_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleCountrySelection(e.target?.value)}
                  value={AreaPayload?.country_id}
                  disabled={countryIdSelected === true}
                  title={
                    CountryData.find(el => el?.id === AreaPayload?.country_id)
                      ?.label || t(`Location_Manager.Select Country`)
                  }
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Country`)}
                  </option>
                  {CountryData &&
                    CountryData.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.country_id && (
                  <small className="text-danger"> {errors?.country_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Region`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>

                <select
                  type="select"
                  name="region_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={AreaPayload?.region_id}
                  onChange={e => handleRegionSelection(e.target?.value)}
                  title={
                    document.querySelector(
                      'select[name="region_id"] option:checked'
                    )?.textContent
                  }
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Region`)}
                  </option>
                  {RegionData &&
                    RegionData?.filter(
                      reg => reg?.country_id == AreaPayload?.country_id
                    )?.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {/* {errors?.region_id && (
                  <small className="text-danger"> {errors?.region_id} </small>
                )} */}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.State`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="state_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={AreaPayload?.state_id}
                  onChange={e => handleStateSelection(e.target?.value)}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select State`)}
                  </option>
                  {StateData &&
                    StateData?.filter(st => {
                      let flag = false;

                      if (AreaPayload?.country_id && !AreaPayload?.region_id) {
                        flag = st?.country_id == AreaPayload?.country_id;
                      } else if (
                        AreaPayload?.country_id &&
                        AreaPayload?.region_id
                      ) {
                        flag =
                          st?.country_id == AreaPayload?.country_id &&
                          st?.region_id == AreaPayload?.region_id;
                      }

                      return flag;
                    }).map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.state_id && (
                  <small className="text-danger"> {errors?.state_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.City`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="city_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={AreaPayload?.city_id}
                  onChange={e => handleCitySelection(e.target?.value)}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select City`)}
                  </option>
                  {CityData &&
                    CityData?.filter(city => {
                      let flag = false;

                      let { country_id, region_id, state_id } =
                        AreaPayload || {};

                      if (country_id && region_id && state_id) {
                        flag =
                          country_id == city?.country_id &&
                          region_id == city?.region_id &&
                          state_id == city?.state_id;
                      } else if (country_id && !region_id && state_id) {
                        flag =
                          country_id == city?.country_id &&
                          state_id == city?.state_id;
                      }

                      return flag;
                    }).map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.city_id && (
                  <small className="text-danger"> {errors?.city_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="area-name-input">
                  {t(`Location_Manager.Area Name`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  id="area-name-input" // Unique ID for the input field
                  type="text"
                  placeholder={t(`Location_Manager.Area Name`)}
                  name="area_name"
                  value={AreaPayload?.area_name}
                  onChange={handleInput}
                  title={t(`Location_Manager.Area Name`)}
                />
                {errors?.area_name && (
                  <small className="text-danger"> {errors?.area_name} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="area-code-input">
                  {t(`Location_Manager.Area Code`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>
                <Form.Control
                  id="area-code-input" // Unique ID for the input field
                  type="text"
                  placeholder={t(`Location_Manager.Area Code`)}
                  name="area_code"
                  value={AreaPayload?.area_code}
                  onChange={handleInput}
                  title={t(`Location_Manager.Area Code`)}
                />
                {errors?.area_code && (
                  <small className="text-danger"> {errors?.area_code} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="email-input">
                  {t(`Location_Manager.Email`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>
                <Form.Control
                  id="email-input" // Unique ID for the input field
                  type="email"
                  placeholder={t(`Location_Manager.Email`)}
                  name="email"
                  value={AreaPayload?.email}
                  onChange={handleInput}
                  title={t(`Location_Manager.Email`)}
                />
                {errors?.email && (
                  <small className="text-danger"> {errors?.email} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Area Manager`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>
                <select
                  type="select"
                  name="area_manager"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={AreaPayload?.area_manager}
                  onChange={e => handleAreaManager(e.target?.value)}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Area Manager`)}
                  </option>
                  {AreaManager &&
                    AreaManager.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.area_manager && (
                  <small className="text-danger">
                    {" "}
                    {errors?.area_manager}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="address-input">
                  {t(`Location_Manager.Address`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>
                <Form.Control
                  id="address-input" // Unique ID for the input field
                  type="text"
                  placeholder={t(`Location_Manager.Address`)}
                  name="address"
                  value={AreaPayload?.address}
                  onChange={handleInput}
                  title={t(`Location_Manager.Address`)}
                />
                {errors?.address && (
                  <small className="text-danger"> {errors?.address} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Select Status`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                  value={AreaPayload?.status}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="1">{t(`Location_Manager.Active`)}</option>
                  <option value="0">{t(`Location_Manager.Inactive`)}</option>
                </select>
              </Form.Group>
            </Row>

            <Form.Group className="cta text-center d-flex gap-3 justify-content-left mt-4 pb-2">
              <Link to="/area-list" className="btn btn-secondary">
                {t(`Location_Manager.Cancel`)}
              </Link>
              <ButtonLoader
                title={t(`Location_Manager.Save Details`)}
                variant="primary"
                type="submit"
                loading={isLoading}
                message={t(`Location_Manager.Saving`)}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EditArea;
